import { createStore } from '@stencil/store';

const appStore = createStore({
  hasLogoutTimeoutId: false,
  logoutTimeoutId: setTimeout(() => {
    // empty
  }, 0),
});

export default appStore;
